module.exports = {
    "baseUrl": "https://api-v4.staging.iris-health.com",
    "systemName": "System dev",
    "stripeKey": "pk_test_51Ia02yIg43ZjHHGkNp1xNEhAYWFGkVQQBSKrNy9zCbK82wjPXTq7mROyYGjQd23qTEjiJt9zTaQHEVos9Ty4eXd700iya1BPmo",
    "companyTitle": "Iris Check in",
    "metaTitle": "Trillium Check in",
    "metaDescription": "Scheduler for physicians and clinics from Iris Health",
    "favicon": "%PUBLIC_URL%/iris/iconWhite.ico",
    "companyName": "Iris Health",
    "copyRight": "Iris Health is a trademark of its respective owner.",
    "companyKey": "iris",
    "redirectUrl": "https://www.iris-health.com/",
    "cdnUrl": "https://cdn.staging.iris-health.com"
}